import { ICreateThemeColorsParams } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

import { HANTEC_GENERIC_THEME_COLORS } from './tenant/hantec';

export const HANTEC_DARK_THEME_COLORS: ICreateThemeColorsParams = {
  ...HANTEC_GENERIC_THEME_COLORS,
  background: {
    default: 'rgb(0,0,0)',
    subtle: 'rgb(18, 18, 18)',
    active: 'rgb(33, 33, 33)'
  }
};

// No customisation needed for default
export const DARK_THEME_COLORS: ICreateThemeColorsParams = {};
